import Footer from '@main/privacy-center/src/containers/Footer';
import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * The footer props
 */
export interface FooterProps {
  /** The URL of the company's home page */
  homepageUrl: string;
  /** The mail-to email for contact support inquiries */
  supportEmail?: string;
}

/**
 * Page Footer with path
 */
export function FooterWithPath({
  homepageUrl,
  supportEmail,
}: FooterProps): JSX.Element {
  const { pathname } = useLocation();
  const isTranscendPath = pathname.startsWith('/about');
  return (
    <Footer
      isTranscendPath={isTranscendPath}
      homepageUrl={homepageUrl}
      supportEmail={supportEmail}
    />
  );
}

export default FooterWithPath;
